<template>
  <div class="app-container">
    <div class="filter-container">

      <div class="filter-left">
        <div class="filter-item" style="min-width:440px;">
          <span style="margin-right: 10px;">注册时间：</span>
          <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <el-input v-model="listQuery.user_account_name" placeholder="用户名/电话" clearable />
        </div>


        <div class="filter-item">
          <el-select v-model="listQuery.gender" placeholder="性别" clearable>
            <el-option label="男" :value="1" />
            <el-option label="女" :value="2" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="listQuery.age_group" placeholder="年龄段" clearable>
            <el-option label="20岁以下" :value="1" />
            <el-option label="21~30岁" :value="2" />
            <el-option label="31~40岁" :value="3" />
            <el-option label="41~50岁" :value="4" />
            <el-option label="51岁以上" :value="5" />
          </el-select>
        </div>
        <div class="filter-item">
          <!-- <el-select v-model="listQuery.perfect" placeholder="居住地" clearable>
            <el-option label="完善" :value="1" />
            <el-option label="缺失" :value="0" />
          </el-select> -->
          <el-cascader v-model="currentCity" :options="cityOptions" :props="{ checkStrictly: true }" placeholder="居住地"
            clearable></el-cascader>
        </div>

        <div class="filter-item">
          <el-select v-model="listQuery.type" placeholder="状态" clearable>
            <el-option label="正常" :value="1" />
            <el-option label="冻结" :value="0" />
          </el-select>
        </div>
      </div>

      <div class="filter-right">
        <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button type="warning" :loading="listLoading" icon="el-icon-upload2" @click="exportExcel">导出Excel</el-button>
      </div>

    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit height="70vh"
      highlight-current-row>
      <el-table-column prop="id" align="center" label="ID" min-width="60" />
      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px" :src="scope.row.head_img" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" min-width="80" align="center" />
      <el-table-column prop="account" label="联系电话" min-width="80" align="center" />
      <el-table-column label="性别" min-width="50" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.gender === 0 || scope.row.gender === null">未设置</span>
          <span v-else-if="scope.row.gender === 1">男</span>
          <span v-else-if="scope.row.gender === 2">女</span>
          <span v-else>后端无字段</span>
        </template>
      </el-table-column>
      <el-table-column label="是否完善资料" min-width="95" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.perfect === 1" type="success">
            是
          </el-tag>
          <el-tag v-else type="danger">
            否
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="年龄段" min-width="60" align="center">
        <template slot-scope="scope">
          <div>{{
            scope.row.age_group === 1 ? '20岁以下' :
            scope.row.age_group === 2 ? '21~30岁' :
              scope.row.age_group === 3 ? '31~40岁' :
                scope.row.age_group === 4 ? '41~50岁' :
                  scope.row.age_group === 5 ? '51岁以上' : '未设置'
          }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="wx_id" label="微信ID" min-width="60" align="center" />
      <el-table-column label="居住地" min-width="60" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.country }},{{ scope.row.provinces }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="invite_num" label="邀请人数" min-width="80" align="center" />

      <!-- <el-table-column prop="invite_num" label="渠道来源" min-width="80" align="center" /> -->

      <el-table-column class-name="status-col" label="渠道来源" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.parent_channel ? scope.row.parent_channel.channel.name : (scope.row.parent ?
            scope.row.parent.user_info.name : '') }}
        </template>
      </el-table-column>


      <el-table-column prop="integral" label="积分" min-width="60" align="center" />
      <el-table-column prop="raffle_num" label="抽奖次数" min-width="80" align="center" />
      <el-table-column prop="created_at" label="注册时间" min-width="80" align="center" />
      <el-table-column prop="last_login_at" label="最近登陆时间" min-width="95" align="center" />
      <el-table-column class-name="status-col" label="状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.type === 0" type="warning">冻结</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="备注" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.remarks }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="230" class-name="small-padding fixed-width">
        <!-- <template slot-scope="scope"> -->
        <div style="margin: -3px;" slot-scope="scope">
          <el-button style="margin: 3px" size="mini" @click="viewInvitationRecord(scope.row.id)">邀请记录</el-button>
          <el-button style="margin: 3px" size="mini" @click="viewUserProfile(scope.row.id)">查看完善资料</el-button>
          <el-button style="margin: 3px" size="mini" @click="viewPointBreakdown(scope.row)">积分明细</el-button>
          <el-button style="margin: 3px" size="mini" @click="viewPointActionModal(scope.row.id)">赠送抽奖</el-button>
          <el-button style="margin: 3px" v-if="scope.row.type === 1" type="warning" size="mini"
            @click="handleForbid(scope.row.id, '冻结')">
            冻结</el-button>
          <el-button style="margin: 3px" v-else size="mini" type="primary"
            @click="handleForbid(scope.row.id, '解冻')">解冻</el-button>
        </div>
        <!-- </template> -->
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <InvitationRecord v-if="invitationRecordVisible" :show.sync="invitationRecordVisible" :userID="viewUserId" />
    <UserProfiileModal v-if="userProfileVisible" :show.sync="userProfileVisible" :userID="viewUserId" :showRemark="true"
      @onUpdate="getList" />
    <PointBreakdown v-if="pointBreakdownVisible" :show.sync="pointBreakdownVisible" :userID="viewUserId"
      :userName="viewUserName" />
    <PointActionModal v-if="pointActionModalVisible" :show.sync="pointActionModalVisible" :userID="viewUserId"
      @onUpdate="getList" />
  </div>
</template>

<script>
// 用户列表

import { user } from "@/api/userManagement"
import request from "@/utils/request";
import InvitationRecord from "./components/InvitationRecord"
import UserProfiileModal from "@/components/UserProfileModal/index"
import PointBreakdown from "./components/PointBreakdown"
import PointActionModal from "./components/PointActionModal"
import * as XLSX from "xlsx"
import { platformList } from "@/utils/common"
import {cityList} from "@/utils/chineseCity"

export default {
  data() {
    return {
      cityOptions: [],

      // 城市选择后的值
      currentCity: [],
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        time_1: null,
        time_2: null,
        user_account_name: '',
        type: null,
        perfect: null,

        gender: null,
        age_group: null,
        country: null,
        provinces: null,
      },
      filteDateRange: null,
      // 拟态
      invitationRecordVisible: false,
      userProfileVisible: false,
      pointBreakdownVisible: false,
      pointActionModalVisible: false,
      viewUserId: null,
      viewUserName: null,
      dateList: []
    };
  },
  created() {

    // cityList.forEach(item1=>{
    //   item1.children.sort((a,b)=>{
    //     return a.value.localeCompare(b.value); 
    //   })
    // })
    this.cityOptions = cityList
    
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;

      this.listQuery.country = this.currentCity[0]
      this.listQuery.provinces = this.currentCity[1]
      console.log(this.listQuery)

      this.list = []
      const { data } = await user.list(this.listQuery)
      this.list = data.data;
      this.total = data.total;

      this.listLoading = false;
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList();
    },
    onChangeDateRange(t) {
      if (t === null) {
        this.listQuery.time_1 = null
        this.listQuery.time_2 = null
        return
      }
      this.listQuery.time_1 = t[0]
      this.listQuery.time_2 = t[1]
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/frozen",
            method: "POST",
            params: { user_id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    viewInvitationRecord(id) {
      this.viewUserId = id
      this.invitationRecordVisible = true
    },
    viewPointBreakdown({ id, name }) {
      this.viewUserId = id
      this.viewUserName = name
      this.pointBreakdownVisible = true
    },
    viewPointActionModal(id) {
      this.viewUserId = id
      this.pointActionModalVisible = true
    },
    viewUserProfile(id) {
      this.viewUserId = id
      this.userProfileVisible = true
    },
    async exportExcel() {
      console.log('exportExcel')
      // +++修改excel-用户列表-附件6---ok
      const { total } = this
      if (!total) return

      try {
        const { data: { data: reqData } } = await user.exportUserinfoExcel({ ...this.listQuery, page: 1, limit: 99999999999 })
        console.log(reqData);
        var wb = XLSX.utils.book_new();

        let platformNameList = [] // 一级标题
        let platformTypeList = [] // 二级标题
        let headerNum = 20 // 前面多少项

        platformList.forEach(item => {
          platformNameList.push(...item.nameList)
          platformTypeList.push(...item.typeList)
        })

        // 前面20项空值
        for (let i = 0; i < headerNum; i++) {
          platformNameList.unshift('')
        }


        // 重置推广数据
        reqData.forEach(reqDataItem => {
          // 渠道数据
          reqDataItem.channelsLists = []
          // 有渠道列表
          if (reqDataItem.user_channel.length > 0) {
            // 遍历本地固定数据
            for (let i = 0; i < platformList.length; i++) {
              let platformItem = platformList[i];
              let flag = false
              let user_channelData = []
              // 遍历后台数据
              for (let dataIndex = 0; dataIndex < reqDataItem.user_channel.length; dataIndex++) {
                const user_channelItem = reqDataItem.user_channel[dataIndex];
                if (flag) continue
                // 如果该项有数据就填充数据，无数据就为空
                if (user_channelItem.evaluation_channel_id === platformItem.id) {
                  user_channelData = user_channelItem.data
                  let urlData = {} // 把第一个是链接的数据拿出来
                  let urlFlag = false // 判断第一个是不是链接

                  // 过滤不是链接的数据
                  user_channelData = user_channelItem.data.filter((item, i) => {
                    if (item.name === "链接" && i === 0) {
                      urlData = item
                      urlFlag = true
                      return false
                    } else {
                      return true
                    }
                  })

                  if (urlFlag) {
                    // 微博
                    if (user_channelItem.evaluation_channel_id === 3) {
                      user_channelData.splice(user_channelData.length - 1, 0, urlData);
                    } else {
                      user_channelData.push(urlData)
                    }
                  }

                  // 微信朋友圈
                  if (user_channelItem.evaluation_channel_id === 4) {
                    user_channelData = user_channelItem.data.filter(item => item.name !== "名称").reverse()
                  }
                  flag = true
                } else {
                  flag = false
                }
              }
              // 通过flag判断有没有该平台的信息，有则赋值，没有则赋空值
              if (flag) {
                reqDataItem.channelsLists.push(...user_channelData.map(item => item.content))
              } else {
                reqDataItem.channelsLists.push(...platformItem.nameList.map(_ => ''))
              }
              // console.log(reqDataItem.channelsLists)

            }
          } else { // 没有渠道数据
            reqDataItem.channelsLists = platformTypeList.map(platformTypeItem => '')
          }

        })

        var excelData = [
          platformNameList,
          ['ID', '昵称', '性别', '年龄', '手机号/电话', '居住地-国家', '居住地-省份', '微信ID', '邮箱', '擅长领域', '是否完善资料', '探店活动次数', '商品体验次数', '渠道来源', '邀请人数', '积分', '抽奖次数', '注册时间', '最近登陆时间', '状态', ...platformTypeList],
          ...reqData.map((item) => [
            item.id,
            item.name,
            item.gender === 1 ? '男性' : item.gender === 2 ? '女性' : '未设置',
            item.age_group === 1 ? '20岁以下' : item.age_group === 2 ? '21~30岁' : item.age_group === 3 ? '31~40岁' : item.age_group === 4 ? '41~50岁' : item.age_group === 5 ? '51岁以上' : '未设置',
            item.account,
            item.country,
            item.provinces,
            item.wx_id,
            item.email,
            item.evaluation_type_field.length > 0 ? item.evaluation_type_field.map(item => item.name).join(',') : '',
            item.perfect ? '是' : '否',
            item.offline_num,
            item.online_num,
            item.parent_channel ? item.parent_channel.channel.name : (item.parent ? item.parent.user_info.name : ''),
            item.invite_num,
            item.integral,
            item.raffle_num,
            item.created_at,
            item.last_login_at,
            item.type ? '正常' : '冻结',
            ...item.channelsLists
          ])
        ];
        var ws = XLSX.utils.aoa_to_sheet(excelData);

        // 合并一级标题所在的单元格
        // const firstHeaderCellStyle = { alignment: { horizontal: 'center', vertical: 'center' } };
        // ws['U1'].s = firstHeaderCellStyle;
        // ws['Y1'].s = firstHeaderCellStyle;
        // ws['AC1'].s = firstHeaderCellStyle;

        // 定义合并的范围
        const mergeCells = platformList.map(item => {
          let obj = { s: { r: 0, c: headerNum }, e: { r: 0, c: headerNum + item.nameList.length - 1 } } //索引从0开始
          headerNum = headerNum + item.nameList.length
          return obj
        });

        // 设置合并的单元格
        ws['!merges'] = mergeCells;

        XLSX.utils.book_append_sheet(wb, ws, "用户列表");
        XLSX.writeFile(wb, "用户列表.xlsx");

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...'
        });
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!'
        });
      }
    }
  },
  components: {
    InvitationRecord,
    PointBreakdown,
    UserProfiileModal,
    PointActionModal
  },
  watch: {
    dateList: {
      handler(nval) {
        if (nval) {
          this.listQuery.time_1 = nval[0]
          this.listQuery.time_2 = `${nval[1]} 23:59`
        } else {
          this.listQuery.time_1 = this.listQuery.time_2 = ''
        }
      },
      deep: true
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
  // align-items: center;

  .filter-left {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;

    .filter-item {
      text-align: center;
      margin-top: 10px;

      .filter-name {
        font-size: 13px;
        margin-right: 6.5px;
        color: #606266;
      }
    }
  }

  .filter-right {
    flex-shrink: 0;
    width: 250px;
    margin-top: 10px;
  }

}
</style>
